export default __webpack_public_path__ + "static/dumpster-rental-7fd4c9a041368c43f7b5460d94965a02.jpg";